import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero-clean-layout" id="hero">
            <div className="hero-image-container">
                <img
                    src="/images/hero-banner.jpg"
                    alt="Embrace Beauty Clinic"
                    className="hero-fullscreen-img"
                />
            </div>
        </section>
    );
};

export default Hero;
